import React, { useEffect, useState, useContext } from "react";
import Dashboard from "../../layouts/Dashboard";
import { If } from "react-condition";

import TextField from "./ApplicationBuilder/TextField";
import Subheading from "./ApplicationBuilder/Subheading";
import Heading from "./ApplicationBuilder/Heading";
import Checkbox from "./ApplicationBuilder/Checkbox";
import Radio from "./ApplicationBuilder/Radio";
import TextArea from "./ApplicationBuilder/TextArea";
import Divider from "./ApplicationBuilder/Divider";
import Select from "./ApplicationBuilder/Select";
import TextTable from "./ApplicationBuilder/TextTable";
import DateField from "./ApplicationBuilder/DateField";
import EmailField from "./ApplicationBuilder/EmailField";
import NumberField from "./ApplicationBuilder/NumberField";
import Paragraph from "./ApplicationBuilder/Paragraph";
import { useRef } from "react";
import Axios from "axios";
import url from "../../services/url";
import { useHistory } from "react-router-dom";
import PasswordField from "./ApplicationBuilder/PasswordField";
import PersonalDetails from "./ApplicationBuilder/PersonalDetails";
import MultiSelect from "./ApplicationBuilder/multiSelect";
import FileInput from "./ApplicationBuilder/FileInput";
import { message } from "antd";
import isConsultant from "../../services/isConsultant";
import { ContextApi } from "../../App";
import ProfessionalExperience from "./ApplicationBuilder/ProfessionalExperience";
import StateCity from "./ApplicationBuilder/StateCity";
import PhotoCapture from "./ApplicationBuilder/PhotoCapture";
import DateTime from "./ApplicationBuilder/DateTime";
import DeptDesg from "./ApplicationBuilder/DeptDesg";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

// import PersonalDetails from "../Candidate/ApplicationView.PersonalDetails";

function ApplicationBuilder() {
  // States
  const [form, setForm] = useState([]);
  const [trfs, setTrfs] = useState([]);
  const [formType, setFormType] = useState("");
  const contextData = useContext(ContextApi);

  const userRole = useRole();
  const [canCreate, setCanCreate] = useState(false);

  const checkPermissions = async () => {
    try {
      const allowed = await checkPermission(
        userRole,
        "formbuilder_module",
        "create"
      );
      setCanCreate(allowed);
    } catch (err) {
      console.error("Error checking permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  // Effects
  useEffect(() => {
    Axios.get(url("/trf"), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    })
      .then((res) => {
        setTrfs(res.data);
      })
      .catch(console.error);
  }, []);

  // Re className="custom-control custom-checkbox"fs
  // const requiredCandidatePhotoRef = useRef();
  // const requiredCandidatePhotoRequiredRef = useRef();
  // const requiredCandidateVideoRef = useRef();
  // const requiredCandidateVideoRequiredRef = useRef();
  // const requiredResumeRef = useRef();
  // const requiredResumeRequiredRef = useRef();
  // const trfRef = useRef();
  // const stateCityRef = useRef();

  // History
  const history = useHistory();

  // Functions
  function getFormComponent(type) {
    switch (type) {
      case "text":
        return TextField;
      case "location":
        return TextField;
      case "textarea":
        return TextArea;
      case "subheading":
        return Subheading;
      case "heading":
        return Heading;
      case "checkbox":
        return Checkbox;
      case "radio":
        return Radio;
      case "divider":
        return Divider;
      case "select":
        return Select;
      case "texttable":
        return TextTable;
      case "date":
        return DateField;
      case "email":
        return EmailField;
      case "number":
        return NumberField;
      case "password":
        return PasswordField;
      case "paragraph":
        return Paragraph;
      case "multiSelect":
        return MultiSelect;
      case "file":
        return FileInput;
      case "professionalexperience":
        return ProfessionalExperience;
      case "statecity":
        return StateCity;
      case "capturephoto":
        return PhotoCapture;
      case "datetime":
        return DateTime;
      case "departmentdesignation":
        return DeptDesg;
      default:
        return () => <div>Unknown Type of Component</div>;
    }
  }

  // Events
  function onToolDragStart(event) {
    event.dataTransfer.setData("element", event.target.getAttribute("element"));
  }

  function onBuilderDrop(event) {
    event.preventDefault();
    const elementType = event.dataTransfer.getData("element");
    setForm((form) => {
      return [...form, getFormComponent(elementType)];
    });
  }

  function onBuilderDragOver(event) {
    event.preventDefault();
  }
  const [error, setError] = useState("");

  const [errorFormType, setErrorFormType] = useState("");

  function onSaveApplicationTemplateClick(event) {
    event.preventDefault();
    setError();
    if (formType !== "") {
      let test = "";

      let formName = document.querySelector("#formName").value;

      let formBuilderElements = [
        ...document.querySelectorAll(".form-builder-element"),
      ];
      formBuilderElements = formBuilderElements.map((element) =>
        JSON.parse(element.getAttribute("data"))
      );

      //duplicate label validations
      // const filterNullVal = formBuilderElements.filter((ele) => {
      //   return ele !== null;
      // });
      // let valueArr = filterNullVal.map(function (item) {
      //   if (item !== null) {
      //     return item.properties.label;
      //   }
      // });
      // let isDuplicate = valueArr.some(function (item, idx) {
      //   return valueArr.indexOf(item) != idx;
      // });

      // if (isDuplicate) {
      //   message.error("Duplicate Label Name exist!", 5);
      // } else {
      const filterNull = formBuilderElements.filter((ele) => {
        return ele !== null;
      });
      const unique = filterNull.filter(
        (a, i) => filterNull.findIndex((s) => a.id === s.id) === i
      );
      let form = {
        name: formName,
        elements: unique,
        formType: formType,
        // cityState: stateCityRef.current.checked,
        // candidatePhoto: requiredCandidatePhotoRef.current.checked,
        // candidateVideo: requiredCandidateVideoRef.current.checked,
        // resume: requiredResumeRef.current.checked,
        // candidatePhotoRequired:
        //   requiredCandidatePhotoRequiredRef.current.checked,
        // candidateVideoRequired:
        //   requiredCandidateVideoRequiredRef.current.checked,
        // resumeRequired: requiredResumeRequiredRef.current.checked,
        // trf: trfRef.current.value,
      };
      // Axios.post(url("formtemplate"), form)
      //   .then((result) => {
      //     history.push("/forms");
      //   })
      //   .catch((error) => console.error(error));
      var nameRegex = new RegExp(/[^A-Z -]/gi);
      if (formName !== "" && formName.length < 50 && formName.length > 4) {
        console.log("form template", form);
        Axios.post(url("formtemplate"), form, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        })
          .then((result) => {
             history.push("/form-templates");
          })
          .catch((error) => console.error(error));
      } else {
        setError("Minimum four character required ");
      }
    } else {
      setErrorFormType("Form Type is required");
    }
  }

  function onElementMoveUp(event) {
    var formBuilder = event.target.parentNode;
    if (!event.target.parentNode.classList.contains("form-builder-element")) {
      formBuilder = event.target.parentNode.parentNode;
    }
    if (formBuilder.previousSibling !== null) {
      formBuilder.parentNode.insertBefore(
        formBuilder,
        formBuilder.previousSibling
      );
    }
    return;
  }

  function onElementMoveDown(event) {
    var formBuilder = event.target.parentNode;
    if (!event.target.parentNode.classList.contains("form-builder-element")) {
      formBuilder = event.target.parentNode.parentNode;
    }
    if (formBuilder.nextSibling !== null) {
      if (formBuilder.nextSibling.nextSibling !== null) {
        formBuilder.parentNode.insertBefore(
          formBuilder,
          formBuilder.nextSibling.nextSibling
        );
      } else {
        formBuilder.parentNode.append(formBuilder);
      }
    }
    return;
  }

  function onElementDelete(event, id) {
    var formBuilder = event.target.parentNode;
    if (!event.target.parentNode.classList.contains("form-builder-element")) {
      formBuilder = event.target.parentNode.parentNode;
    }
    formBuilder.parentNode.removeChild(formBuilder);
    contextData.setContextData({
      ...contextData.contextData,
      isDeletedArr: [...contextData.contextData.isDeletedArr, id],
    });
  }

  // Render
  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="Application Form Builder">
          <div className="row">
            {/* Form Builder */}
            <div className="col-md-9">
              <h4 className="mb-4">Form Preview</h4>
              <PersonalDetails />
              <div
                className="builder mb-5"
                onDrop={onBuilderDrop}
                onDragOver={onBuilderDragOver}
              >
                <If test={form.length === 0}>
                  <h4>Drag and Drop elements from toolbar here.</h4>
                  <span>
                    For best experience drag and drop elements first andf then
                    apply conditional logic.
                  </span>
                  <br />
                  <p>
                    Note:-
                    <ul>
                      <li>Only Select field can be set to Parent.</li>
                      <li>There can be multiple child in one parent value.</li>
                      <li>
                        labels- Name, Email & Phone Number cannot set as child.
                      </li>
                      <li>
                        Once the element is set as child, it will be visible
                        under that parent only.
                      </li>
                      <li>Name, Email & Phone Number are mandatory fields.</li>
                      <li>
                        Upload Resume and Candidate photo- (set Labels like
                        this:- Resume ,Candidate Photo)
                      </li>
                    </ul>
                  </p>
                </If>
                {Object.entries(form).map(([key, Element]) => (
                  <Element
                    key={key}
                    onMoveUp={onElementMoveUp}
                    onMoveDown={onElementMoveDown}
                    onElementDelete={onElementDelete}
                  />
                ))}
              </div>

              {/* <div
                style={{ display: "flex", flexDirection: "row", gap: "10px" }}
              >
                <label for="cars">Select Form Type</label>
                <select
                  onClick={(e) => {
                    setErrorFormType("");
                    setFormType(e.target.value);
                  }}
                  style={{ width: "30%" }}
                  className="form-control"
                  name="cars"
                  id="cars"
                >
                  <option value="">Select Form Type</option>
                  <option value="Skill_Form">Skill Form</option>
                  <option value="Apply_Form">Apply Form</option>
                  <option value="Document_Form">Document Form</option>
                </select>
              </div> */}
              {/* <p style={{ color: "red" }}>{errorFormType}</p> */}
              {/* <div className="mb-3 d-flex">
            <div className="custom-control custom-checkbox mb-2">
              <input
                ref={requiredCandidatePhotoRef}
                id="requiredCandidatePhoto"
                type="checkbox"
                className="custom-control-input"
              />
              <label
                htmlFor="requiredCandidatePhoto"
                className="custom-control-label"
              >
                Candidate Photo
              </label>
            </div>
            <div className="custom-control custom-checkbox ml-3">
              <input
                ref={requiredCandidatePhotoRequiredRef}
                id="requiredCandidatePhotoRequired"
                type="checkbox"
                className="custom-control-input ml-5"
              />
              <label
                htmlFor="requiredCandidatePhotoRequired"
                className="custom-control-label"
              >
                Mandatory
              </label>
            </div>
          </div>
          <div className="mb-3 d-flex">
            <div className="custom-control custom-checkbox mb-2">
              <input
                ref={requiredCandidateVideoRef}
                id="requiredCandidateVideo"
                type="checkbox"
                className="custom-control-input"
              />
              <label
                htmlFor="requiredCandidateVideo"
                className="custom-control-label"
              >
                Candidate Video
              </label>
            </div>
            <div className="custom-control custom-checkbox ml-3">
              <input
                ref={requiredCandidateVideoRequiredRef}
                id="requiredCandidateVideoRequired"
                type="checkbox"
                className="custom-control-input ml-5"
              />
              <label
                htmlFor="requiredCandidateVideoRequired"
                className="custom-control-label"
              >
                Mandatory
              </label>
            </div>
          </div>
          <div className="mb-3 d-flex">
            <div className="custom-control custom-checkbox mb-2">
              <input
                ref={requiredResumeRef}
                id="requiredResume"
                type="checkbox"
                className="custom-control-input"
              />
              <label htmlFor="requiredResume" className="custom-control-label">
                Resume
              </label>
            </div>
            <div className="custom-control custom-checkbox ml-3">
              <input
                ref={requiredResumeRequiredRef}
                id="requiredResumeRequired"
                type="checkbox"
                className="custom-control-input ml-5"
              />
              <label
                htmlFor="requiredResumeRequired"
                className="custom-control-label"
              >
                Mandatory
              </label>
            </div>
          </div> */}
              <div className="mb-3 d-flex">
                {/* <div className="custom-control custom-checkbox mb-2">
              <input
                ref={stateCityRef}
                id="stateCity"
                type="checkbox"
                className="custom-control-input"
              />
              <label
                htmlFor="stateCity"
                className="custom-control-label"
              >
                Add State And City Controller
              </label>
            </div> */}
              </div>

              <div className="form-group">
                {/* previous trf link-up with form */}
                {/* <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text input-group-text-min-width-form">
                  Form TRF
                </span>
              </div>
              <select ref={trfRef} id="trf" className="form-control">
                {trfs.map((trf) => (
                  <option value={trf._id} key={trf._id}>
                    {trf.title}
                  </option>
                ))}
              </select>
            </div> */}
              </div>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text input-group-text-min-width-form">
                      Select Form Type
                    </span>
                  </div>
                  <select
                    onChange={(e) => {
                      setErrorFormType("");
                      setFormType(e.target.value);
                    }}
                    style={{ width: "30%" }}
                    className="form-control"
                    name="cars"
                    id="cars"
                  >
                    <option value="">Select Form Type</option>
                    <option value="Skill_Form">Skill Form</option>
                    <option value="Joining_Form">Joining Form</option>
                    <option value="Document_Form">Document Form</option>
                    <option value="Feedback_Form">Feedback Form</option>
                  </select>
                </div>
              </div>
              <p style={{ color: "red" }}>{errorFormType}</p>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text input-group-text-min-width-form">
                      Form Name
                    </span>
                  </div>
                  <input
                    id="formName"
                    type="text"
                    className="form-control"
                    placeholder="Enter Form Template name here"
                    required
                  />
                </div>
                <p style={{ color: "red" }}>{error}</p>
              </div>
              <div className="form-group">
                {canCreate && (
                  <button
                    className="btn btn-primary"
                    onClick={onSaveApplicationTemplateClick}
                  >
                    Create Form
                  </button>
                )}
              </div>
            </div>

            {/* Toolbar */}
            <div className="col-md-3">
              <div className="toolbox-parent">
                <div className="toolbox">
                  <h4 className="mb-4">Toolbar</h4>
                  <div className="row">
                    <div className="col-md-12 col-lg-6">
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="text"
                      >
                        Text Field
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="paragraph"
                      >
                        Paragraph
                      </div>

                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="textarea"
                      >
                        Text Area
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="checkbox"
                      >
                        Checkbox
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="divider"
                      >
                        Divider
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="texttable"
                      >
                        Text Table
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="email"
                      >
                        Email
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="file"
                      >
                        File
                      </div>
                      <div
                        className="builder-tool text-center"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="capturephoto"
                      >
                        Capture Photo
                      </div>
                      <div
                        className="builder-tool text-center"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="datetime"
                      >
                        Date Time
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-6">
                      {/* <div className="builder-tool" onDragStart={onToolDragStart} draggable={true} element="heading">
                    Group Heading
                  </div> */}
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="subheading"
                      >
                        Heading
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="radio"
                      >
                        Radio Button
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="select"
                      >
                        Select
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="date"
                      >
                        Date
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="number"
                      >
                        Number
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="password"
                      >
                        Password
                      </div>
                      <div
                        className="builder-tool"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="multiSelect"
                      >
                        MultiSelect
                      </div>
                      <div
                        className="builder-tool text-center"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="professionalexperience"
                      >
                        Professional Experience
                      </div>
                      <div
                        className="builder-tool text-center"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="statecity"
                      >
                        State City
                      </div>
                      <div
                        className="builder-tool text-center"
                        onDragStart={onToolDragStart}
                        draggable={true}
                        element="departmentdesignation"
                      >
                        Department Description
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Dashboard>
      )}
    </div>
  );
}

export default ApplicationBuilder;
